import { render, staticRenderFns } from "./HorizontalSlider.vue?vue&type=template&id=01fc18e2&scoped=true"
import script from "./HorizontalSlider.vue?vue&type=script&lang=js"
export * from "./HorizontalSlider.vue?vue&type=script&lang=js"
import style0 from "./HorizontalSlider.vue?vue&type=style&index=0&id=01fc18e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fc18e2",
  null
  
)

export default component.exports